import React from 'react';

export default function TopNav() {
    return (
        <nav className="navbar fixed-top">
            <a className="navbar-logo" href="https://akschap.com" aria-label="وب‌سایت عکسچاپ">
                <span className="logo d-none d-xs-block" />
                <span className="logo-mobile d-block d-xs-none" />
            </a>
        </nav>
    );
}
